export function baseURL(): string {
  if (process.env.NODE_ENV === 'development') {
    if (typeof window === 'undefined') {
      return 'http://oversead.poizon.com'
    }
    return ''
  }

  const SENV = process.env.SENV

  if (SENV === 'd1') {
    // 本地环境的接口代理
    return 'http://ft-java-public.poizon.com'
  }
  if (SENV === 't1') {
    // TODO fix
    // return 'http://oversead.poizon.com'
    return 'https://shft1-asia-east-public.poizon.com'
  }
  if (SENV === 'shft') {
    return 'https://shft-asia-east-public.poizon.net'
  }
  if (SENV === 'shft1') {
    return 'https://shft1-asia-east-public.poizon.net'
  }
  if (SENV === 'itxx') {
    return 'https://i-txx-asia-east-public.poizon.net'
  }
  if (SENV === 'imf1') {
    return 'https://i-mf1-asia-east-public.poizon.net'
  }
  if (SENV === 't2') {
    return 'http://ft-java-public.poizon.com'
  }
  if (SENV === 't4') {
    return 'http://oversead.poizon.com'
  }
  if (SENV === 'pre') {
    return 'https://pre-asia-east-public.poizon.com'
  }
  if (SENV === 'pro') {
    return 'https://asia-east-public.poizon.com'
  }
  return 'https://asia-east-public.poizon.com'
}

export function formatUrl(url: string): string {
  const nextUrl = url.startsWith('/') ? `${baseURL()}${url}` : url
  return nextUrl
}
